import http, { getToken } from '@/api/http'

// import {competitions} from "@/utils/common";
export const LOCAL = false
// const DEVMJ = false
// export const url = (uri, params = null) =>
//     `http://${LOCAL ? DEVMJ?"127.0.0.1:8000":"10.79.248.92:8000" : "119.45.201.191:8000"}${uri}${params === null ? "" : "?" + new URLSearchParams(params)}`;
export const url = (uri, params = null) =>
    `${LOCAL ? "http://localhost:8000":"https://cttamatch.sportvis.cn"}${uri}${params === null ? "" : "?" + new URLSearchParams(params)}`;

export const checkTokenValid = () =>
  http.request({
    method: 'get',
    url: url('/user/token_status', { token: getToken() }),
  })

export const userLogin = (options) =>
  http.request({
    ...options,
    url: url('/user/'),
  })

export const userLogout = () =>
  http.request({
    method: 'delete',
    url: url(`/user/`, { token: getToken() }),
  })

export const userRegister = (options) =>
  http.request({
    ...options,
    method: 'get',
    url: '/user/',
  })

export const changePassword = (options) =>
  http.request({
    ...options,
    url: url(`/user/password`, { token: getToken() }),
  })

export const getUserTeam = () =>
  http.request({
    method: 'get',
    url: url(`/user/teams`, { token: getToken() }),
  })
export const checkMaintainData = () =>
  http.request({
    method: 'get',
    url: url(`/user/allow_maintain_data`, { token: getToken() }),
  })

export const getTeamMatches = (team) =>
  http.request({
    method: 'get',
    url: url(`/match/list`, { token: getToken(), team: team }),
  })
export const getTeamMatchesAll = () =>
  http.request({
    method: 'get',
    url: url(`/match/list_all`, { token: getToken() }),
  })
export const updateTeamMatchSelection = (team, options) =>
  http.request({
    ...options,
    url: url(`/match/selection`, { token: getToken(), team: team }),
  })

export const getTeamPlayers = (team) =>
  http.request({
    method: 'get',
    url: url(`/player/list`, { token: getToken(), team: team }),
  })

export const getTeamPlayersAll = () =>
  http.request({
    method: 'get',
    url: url(`/player/list_all`, { token: getToken() }),
  })

export const getTeamPlayersWithoutSelectCheck = (team) =>
  http.request({
    method: 'get',
    url: url(`/player/list_team_all`, { token: getToken(), team: team }),
  })
export const updateTeamPlayerSelection = (team, options) =>
  http.request({
    ...options,
    url: url(`/player/selection`, { token: getToken(), team: team }),
  })

export const getTeamParticipation = (team) =>
  http.request({
    method: 'get',
    url: url(`/player/participation/table`, { token: getToken(), team: team })
  })
export const getPlayerPartner = (player_id, competition_type) =>
  http.request({
    method: 'get',
    url: url(`/player/partner`, { token: getToken(), player_id: player_id, competition_type: competition_type }),
  })
export const getPlayerHeadShot = (wtt_id) =>
  http.request({
    method: 'get',
    url: url(`/player/headshot`, { token: getToken(), wtt_id: wtt_id }),
  })
//   "match_id": "string",
//   "competition_type": "single",
//   "selected": true,
//   "partner_id": "string"
export const updatePlayerParticipationInOneMatch = (player_id, options) =>
  http.request({
    ...options,
    url: url(`/player/participation`, { token: getToken(), player_id: player_id })
  })
export const startGetScoreByName = (CompName, options) =>
  http.request({
    ...options,
    url: url(`/score/start`, { token: getToken(), compName: CompName })
  })
export const startGetScore = (options) =>
  http.request({
    ...options,
    url: url(`/score/updateStorage`, { token: getToken() })
  })
export const forceLoadEventDB = () =>{
    http.request({
        url: url(`/score/force_load_from_db_subevent`, { token: getToken() })
    })
}
export const updateMatchEngName = (match_id, eng_name, options) =>
  http.request({
    ...options,
    url: url(`/score/updateMatchEngName`, { token: getToken(), match_id: match_id, eng_name: eng_name })
  })
export const updatePlayerEngName = (player_id, eng_name, wtt_id, options) =>
  http.request({
    ...options,
    url: url(`/score/updatePlayerEngName`, { token: getToken(), player_id: player_id, eng_name: eng_name, wtt_id: wtt_id })
  })
export const AddSubEvent = (options) =>
    http.request({
        ...options,
        url: url(`/score/submit_subevent`, { token: getToken() })
    })
export const queryGetScore = (CompToken, options) =>
  http.request({
    method: 'get',
    ...options,
    url: url(`/score/query`, { token: getToken(), compToken: CompToken })
  })
export const getScoreResult = (CompToken, options) =>
  http.request({
    method: 'get',
    ...options,
    url: url(`/score/result`, { token: getToken(), compToken: CompToken })
  })
export const getInfoForMapView = (startTime, endTime, player_id) =>
  http.request({
    method: 'get',
    url: url(`/map/query`, { token: getToken(), startTime: startTime, endTime: endTime, player: player_id })
  })
export const getEvent = (match_id, subType, player_id, start_date, end_date, options) => {
  if (typeof match_id === 'string' && typeof subType === 'string' && typeof player_id === 'string' && typeof start_date === 'string' && typeof end_date === 'string') {
    return http.request({
      method: 'get',
      ...options,
      url: url(`/score/event_data_specific_with_medal`, { token: getToken(), match_id: match_id, subType: subType, player_id: player_id, startTime: start_date, endTime: end_date })
    })
    }
    else{
      return "need string,even undefined need to written as empty string"
    }
  }
export const getStatisticParticipation = (startTime,endTime,team,type_single_double_mixed) =>
    http.request({
        method: 'get',
        url: url(`/analysis/statistic_participation`,{token:getToken(),startTime:startTime,endTime:endTime,team:team,type_single_double_mixed:type_single_double_mixed}),
    })
export const getTeamMedal = (team,startTime,endTime) =>
    http.request({
        method: 'get',
        url: url(`/analysis/statistic_team_medal`,{token:getToken(),startTime:startTime,endTime:endTime,team:team}),
    })


export const getMatchResult = (startTime, endTime, team, type_single_double_mixed, targetPlayer, targetPlayerPartner) =>
  http.request({
    method: 'get',
    url: url(`/analysis/match_result`, {token: getToken(), startTime: startTime, endTime: endTime, team: team,
      type_single_double_mixed: type_single_double_mixed, targetPlayer: targetPlayer, targetPlayerPartner: targetPlayerPartner}
    )
  })

export const updateAllCompetitionsSelection = (team, selected, year) =>
  http.request({
    url: url(`/match/selection_all`, { token: getToken(), team: team, selected: selected, year: year }),
  })

export const updateAllPlayersSelection = (team, selected,gender) =>
  http.request({
    url: url(`/player/selection_all`, { token: getToken(), team: team, selected: selected,gender: gender }),
  })
export const getCompTrainingTime = (startTime,endTime) =>
    http.request({
        method:'get',
        url: url(`/analysis/comp_training_time_load`, { token: getToken(),"startTime":startTime,"endTime":endTime})
    })
export const getCompTrainingTimeGen = (startTime,endTime) =>
    http.request({
        method:'get',
        url: url(`/analysis/comp_training_time_gen`, { token: getToken(),"startTime":startTime,"endTime":endTime})
    })

export const getPlayerCurRankingByType = (ranking_type) =>
  http.request({
    method: 'get',
    url: url(`/ranking/get_player_cur_ranking_by_type`, { token: getToken(), ranking_type: ranking_type }),
  })

export const getPlayerRankingById = (ranking_type, player_id_list) =>
    http.request({
        method: 'get',
        url: url(`/ranking/get_player_ranking_by_id`, { token: getToken(), ranking_type: ranking_type, player_id_list: player_id_list }),
    })

export const getPlayerAllRankingByWTTId = (ranking_type, player_id_list) =>
    http.request({
        method: 'get',
        url: url(`/ranking/get_player_all_ranking_by_wtt_id`, { token: getToken(), ranking_type: ranking_type, player_id_list: player_id_list }),
    })

export const getMatchListByDate = (startTime, endTime, ranking_type) =>
    http.request({
        method: 'get',
        url: url(`/ranking/get_match_list_by_date`, { token: getToken(), startTime: startTime, endTime: endTime, ranking_type: ranking_type }),
    })

export const setDeductionPlayer = (selected_player_id_list, selected_player_name_list) =>
    http.request({
        method: 'get',
        url: url(`/ranking/set_deduction_player`, { token: getToken(), selected_player_id_list: selected_player_id_list, selected_player_name_list: selected_player_name_list }),
    })

export const setDeductionMatchId = (selected_match_id_list) =>
    http.request({
        method: 'get',
        url: url(`/ranking/set_deduction_match_id`, { token: getToken(), selected_match_id_list: selected_match_id_list }),
    })

export const addFilterCondition = (new_condition) =>
    http.request({
        method: 'get',
        url: url(`/ranking/add_filter_condition`, { token: getToken(), new_condition: new_condition }),
    })

export const deleteFilterCondition = (condition_id) =>
    http.request({
        method: 'get',
        url: url(`/ranking/delete_filter_condition`, { token: getToken(), condition_id: condition_id }),
    })

export const deleteAllFilterCondition = () =>
    http.request({
        method: 'get',
        url: url(`/ranking/delete_all_filter_condition`, { token: getToken() }),
    })

export const getPlayerHeadshotById = (selected_player_id_list) =>
    http.request({
        method: 'get',
        url: url(`/ranking/get_player_headshot_by_id`, { token: getToken(), selected_player_id_list: selected_player_id_list }),
    })

export const getFilterResults = (selected_condition_id_list) =>
    http.request({
        method: 'get',
        url: url(`/ranking/get_filter_results`, { token: getToken(), selected_condition_id_list: selected_condition_id_list }),
    })

export const getNextGroupOfFilterResults = (begin_index, cnt) =>
    http.request({
        method: 'get',
        url: url(`/ranking/get_next_group_of_filter_results`, { token: getToken(), begin_index: begin_index, cnt: cnt }),
    })
export const getWeeklyReport = () =>
    http.request({
        method:'GET',
        url: url(`/file/score/weekly_report`, { token: getToken()}),responseType: 'blob'
    })

/**
 * 解析blob响应内容并下载
 * @param {*} res blob响应内容
 * @param {String} mimeType MIME类型
 */
export function resolveBlob(res, mimeType) {
  const aLink = document.createElement('a')
  var blob = new Blob([res.data], { type: mimeType })
  // 从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
  var patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
  var contentDisposition = decodeURI(res.headers['content-disposition'])
  var result = patt.exec(contentDisposition)
  var fileName = result[1]
  // fileName = fileName.replace(/"/g, '')
  aLink.href = URL.createObjectURL(blob)
  aLink.setAttribute('download', fileName) // 设置下载文件名称
  document.body.appendChild(aLink)
  aLink.click()
  document.body.removeChild(aLink);
}
/**
 * 下载附件
 * @param team
 */
export const downloadAttachment = (team) =>
  http.request({
    method: 'get',
    // url:`http://47.97.66.50:5000/v1/wallpaper.png`,
    url: url(`/file/participation/table`, { token: getToken(), team: team }),
    responseType: 'blob',
  }).then(res => {
    const blob = new Blob([res.data])
    const fileName = "导出" + `data` + ".xlsx"
    const link = document.createElement('a')
    link.download = fileName
    link.style.display = 'none'
    link.href = URL.createObjectURL(blob)
    document.body.appendChild(link)
    link.click()
    URL.revokeObjectURL(link.href)
    document.body.removeChild(link)
    // console.log(team)
  })

// ==================== 数据维护 API ====================

// 球员表
export const getDataPlayers = (page, pageSize) =>
  http.request({
    method: 'get',
    url: url(`/data/players`, { token: getToken(), page: page, page_size: pageSize }),
  })

export const getDataPlayer = (playerId) =>
  http.request({
    method: 'get',
    url: url(`/data/players/${playerId}`, { token: getToken() }),
  })

export const addDataPlayer = (options) =>
  http.request({
    ...options,
    method: 'put',
    url: url(`/data/players`, { token: getToken() }),
  })

export const updateDataPlayer = (playerId, options) =>
  http.request({
    ...options,
    method: 'post',
    url: url(`/data/players/${playerId}`, { token: getToken() }),
  })

export const deleteDataPlayer = (playerId) =>
  http.request({
    method: 'delete',
    url: url(`/data/players/${playerId}`, { token: getToken() }),
  })

// 比赛表
export const getDataMatches = (page, pageSize) =>
  http.request({
    method: 'get',
    url: url(`/data/matches`, { token: getToken(), page: page, page_size: pageSize }),
  })

export const addDataMatch = (options) =>
  http.request({
    ...options,
    method: 'post',
    url: url(`/data/matches`, { token: getToken() }),
  })

export const updateDataMatch = (matchId, options) =>
  http.request({
    ...options,
    method: 'put',
    url: url(`/data/matches/${matchId}`, { token: getToken() }),
  })

export const deleteDataMatch = (matchId) =>
  http.request({
    method: 'delete',
    url: url(`/data/matches/${matchId}`, { token: getToken() }),
  })

// 赛事表
export const getDataEvents = (page, pageSize) =>
  http.request({
    method: 'get',
    url: url(`/data/events`, { token: getToken(), page: page, page_size: pageSize }),
  })

export const addDataEvent = (options) =>
  http.request({
    ...options,
    method: 'post',
    url: url(`/data/events`, { token: getToken() }),
  })

export const updateDataEvent = (eventId, options) =>
  http.request({
    ...options,
    method: 'put',
    url: url(`/data/events/${eventId}`, { token: getToken() }),
  })

export const deleteDataEvent = (eventId) =>
  http.request({
    method: 'delete',
    url: url(`/data/events/${eventId}`, { token: getToken() }),
  })

// 参赛记录表
export const getDataParticipation = (playerId) =>
  http.request({
    method: 'get',
    url: url(`/data/participation`, { token: getToken(), player_id: playerId }),
  })

export const addDataParticipation = (options) =>
  http.request({
    ...options,
    method: 'post',
    url: url(`/data/participation`, { token: getToken() }),
  })

export const updateDataParticipation = (options) =>
  http.request({
    ...options,
    method: 'put',
    url: url(`/data/participation`, { token: getToken() }),
  })

export const deleteDataParticipation = (playerId, matchId) =>
  http.request({
    method: 'delete',
    url: url(`/data/participation`, { token: getToken(), player_id: playerId, match_id: matchId }),
  })

// 团队球员表
export const getDataTeamPlayers = (team) =>
  http.request({
    method: 'get',
    url: url(`/data/team_player`, { token: getToken(), team: team }),
  })

export const addDataTeamPlayer = (options) =>
  http.request({
    ...options,
    method: 'post',
    url: url(`/data/team_player`, { token: getToken() }),
  })

export const deleteDataTeamPlayer = (playerId, team) =>
  http.request({
    method: 'delete',
    url: url(`/data/team_player`, { token: getToken(), player_id: playerId, team: team }),
  })

// 城市坐标表
export const getDataPositions = () =>
  http.request({
    method: 'get',
    url: url(`/data/position`, { token: getToken() }),
  })

export const addDataPosition = (options) =>
  http.request({
    ...options,
    method: 'post',
    url: url(`/data/position`, { token: getToken() }),
  })

export const updateDataPosition = (cityName, options) =>
  http.request({
    ...options,
    method: 'put',
    url: url(`/data/position/${encodeURIComponent(cityName)}`, { token: getToken() }),
  })

export const deleteDataPosition = (cityName) =>
  http.request({
    method: 'delete',
    url: url(`/data/position/${encodeURIComponent(cityName)}`, { token: getToken() }),
  })

// 批量新增
export const batchAddData = (table, items) =>
  http.request({
    method: 'post',
    url: url(`/data/batch`, { token: getToken(), table: table }),
    data: { items },
  })

// 重载数据
export const reloadData = (target) =>
  http.request({
    method: 'post',
    url: url(`/data/reload`, { token: getToken(), target: target }),
  })
